function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { activeAnimations } from '../../stats/animation-count.mjs';
import { statsBuffer } from '../../stats/buffer.mjs';
import { mapEasingToNativeEasing } from './easing/map-easing.mjs';

function startWaapiAnimation(element, valueName, keyframes) {
  var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
      _ref$delay = _ref.delay,
      delay = _ref$delay === void 0 ? 0 : _ref$delay,
      _ref$duration = _ref.duration,
      duration = _ref$duration === void 0 ? 300 : _ref$duration,
      _ref$repeat = _ref.repeat,
      repeat = _ref$repeat === void 0 ? 0 : _ref$repeat,
      _ref$repeatType = _ref.repeatType,
      repeatType = _ref$repeatType === void 0 ? "loop" : _ref$repeatType,
      _ref$ease = _ref.ease,
      ease = _ref$ease === void 0 ? "easeOut" : _ref$ease,
      times = _ref.times;

  var pseudoElement = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;

  var keyframeOptions = _defineProperty({}, valueName, keyframes);

  if (times) keyframeOptions.offset = times;
  var easing = mapEasingToNativeEasing(ease, duration);
  /**
   * If this is an easing array, apply to keyframes, not animation as a whole
   */

  if (Array.isArray(easing)) keyframeOptions.easing = easing;

  if (statsBuffer.value) {
    activeAnimations.waapi++;
  }

  var options = {
    delay: delay,
    duration: duration,
    easing: !Array.isArray(easing) ? easing : "linear",
    fill: "both",
    iterations: repeat + 1,
    direction: repeatType === "reverse" ? "alternate" : "normal"
  };
  if (pseudoElement) options.pseudoElement = pseudoElement;
  var animation = element.animate(keyframeOptions, options);

  if (statsBuffer.value) {
    animation.finished.finally(function () {
      activeAnimations.waapi--;
    });
  }

  return animation;
}

export { startWaapiAnimation };